<template>
    <span class="authorization-id" v-if="id">
        <span v-html="$t('AuthorizationId.label')"></span> {{ id }}
    </span>
</template>

<script>
    export default {
        name: 'totem-authorization-id',
        props: {
            id: [ String, Number ]
        }
    }
</script>

<style lang="scss" scoped>
    .authorization-id {
        display: inline-flex;
        align-items: center;
        padding: 0 12px;
        margin: 0 6px 6px 0;
        border-radius: 3px;
        height: 22px;
        background: $champagne;
        font-size: 1.4rem;
        color: $black;
    }
</style>
